import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      fr: {
        translation: {
          websiteSummarySendResultBy: 'Envoi des résultats : Par internet',
          postalSummarySendResultBy: 'Envoyer les résultats par courrier',
          smsSummarySendResultBy:
            'Réception des résultats via un lien envoyé par SMS'
        }
      }
    },
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });
